var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid battery-order-view__row battery-order-view__row--header"
      },
      [
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header"
            },
            [_vm._v("Battery Line")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header"
            },
            [_vm._v("Battery Size")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header"
            },
            [_vm._v("Pack Size")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header"
            },
            [_vm._v("Quantity Description")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header"
            },
            [_vm._v("Imprint")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header h-center-align"
            },
            [_vm._v("Quantity")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header h-center-align"
            },
            [_vm._v("Subtotal")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-view__order" }, [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__cell battery-order-view__cell--header"
            },
            [_vm._v(" ")]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }